import PageLayout from 'components/PageLayout';
import React from 'react';

function AssociatesContainer() {
  return <PageLayout>Associates</PageLayout>;
}

export default AssociatesContainer;
